import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnHK: CultureInfo = {
  name: 'en-HK',
  displayName: 'English (Hong Kong)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-HK',
  parent: CultureInfoEn
};
